export const seriesId = [
  "adjusted_income_index",
  "life_expectancy_index",
  "schooling_index",
  "liberal_democracy_index",
  "ahdi",
  "ahdi_excluding_income"
]

export const seriesEsp = [
  "Índice ajustado de ingreso",
  "Índice de esperanza de vida",
  "Índice de Escolarización",
  "Índice de democracia liberal",
  "IDHA (Índice de Desarrollo Humano Aumentado)",
  "IDHA (Excluído el ingreso)"
]

export const seriesEng = [
  "Adjusted income index",
  "Life expectancy index",
  "Schooling index",
  "Liberal democracy index",
  "AHDI (Augmented Human Development Index)",
  "AHDI (Excluding income)"
]

export const countriesJSONEng = [
  "Zimbabwe",
  "Zambia",
  "Yemen",
  "Vietnam",
  "Venezuela",
  "Vatican",
  "Vanuatu",
  "Uzbekistan",
  "Uruguay",
  "Micronesia",
  "Marshall Is.",
  "N. Mariana Is.",
  "U.S. Virgin Is.",
  "Guam",
  "American Samoa",
  "Puerto Rico",
  "United States of America",
  "S. Geo. and the Is.",
  "Br. Indian Ocean Ter.",
  "Saint Helena",
  "Pitcairn Is.",
  "Anguilla",
  "Falkland Is.",
  "Cayman Is.",
  "Bermuda",
  "British Virgin Is.",
  "Turks and Caicos Is.",
  "Montserrat",
  "Jersey",
  "Guernsey",
  "Isle of Man",
  "United Kingdom",
  "United Arab Emirates",
  "Ukraine",
  "Uganda",
  "Turkmenistan",
  "Turkey",
  "Tunisia",
  "Trinidad and Tobago",
  "Tonga",
  "Togo",
  "Timor-Leste",
  "Thailand",
  "Tanzania",
  "Tajikistan",
  "Taiwan",
  "Syria",
  "Switzerland",
  "Sweden",
  "eSwatini",
  "Suriname",
  "S. Sudan",
  "Sudan",
  "Sri Lanka",
  "Spain",
  "South Korea",
  "South Africa",
  "Somalia",
  "Somaliland",
  "Solomon Is.",
  "Slovakia",
  "Slovenia",
  "Singapore",
  "Sierra Leone",
  "Seychelles",
  "Serbia",
  "Senegal",
  "Saudi Arabia",
  "São Tomé and Principe",
  "San Marino",
  "Samoa",
  "St. Vin. and Gren.",
  "Saint Lucia",
  "St. Kitts and Nevis",
  "Rwanda",
  "Russia",
  "Romania",
  "Qatar",
  "Portugal",
  "Poland",
  "Philippines",
  "Peru",
  "Paraguay",
  "Papua New Guinea",
  "Panama",
  "Palau",
  "Pakistan",
  "Oman",
  "Norway",
  "North Korea",
  "Nigeria",
  "Niger",
  "Nicaragua",
  "New Zealand",
  "Niue",
  "Cook Is.",
  "Netherlands",
  "Aruba",
  "Curaçao",
  "Nepal",
  "Nauru",
  "Namibia",
  "Mozambique",
  "Morocco",
  "W. Sahara",
  "Mongolia",
  "Moldova",
  "Montenegro",
  "Monaco",
  "Mexico",
  "Mauritius",
  "Mauritania",
  "Malta",
  "Mali",
  "Maldives",
  "Malaysia",
  "Malawi",
  "Madagascar",
  "Macedonia",
  "Luxembourg",
  "Lithuania",
  "Liechtenstein",
  "Libya",
  "Liberia",
  "Lesotho",
  "Lebanon",
  "Latvia",
  "Laos",
  "Kyrgyzstan",
  "Kuwait",
  "Kosovo",
  "Kiribati",
  "Kenya",
  "Kazakhstan",
  "Jordan",
  "Japan",
  "Jamaica",
  "Italy",
  "Israel",
  "Palestine",
  "Ireland",
  "Iraq",
  "Iran",
  "Indonesia",
  "India",
  "Iceland",
  "Hungary",
  "Honduras",
  "Haiti",
  "Guyana",
  "Guinea-Bissau",
  "Guinea",
  "Guatemala",
  "Grenada",
  "Greece",
  "Ghana",
  "Germany",
  "Georgia",
  "Gambia",
  "Gabon",
  "France",
  "St. Pierre and Miquelon",
  "Wallis and Futuna Is.",
  "St-Martin",
  "St-Barthélemy",
  "Fr. Polynesia",
  "New Caledonia",
  "Fr. S. Antarctic Lands",
  "Åland",
  "Finland",
  "Fiji",
  "Ethiopia",
  "Estonia",
  "Eritrea",
  "Eq. Guinea",
  "El Salvador",
  "Egypt",
  "Ecuador",
  "Dominican Rep.",
  "Dominica",
  "Djibouti",
  "Greenland",
  "Faeroe Is.",
  "Denmark",
  "Czechia",
  "N. Cyprus",
  "Cyprus",
  "Cuba",
  "Croatia",
  "Côte d'Ivoire",
  "Costa Rica",
  "Dem. Rep. Congo",
  "Congo",
  "Comoros",
  "Colombia",
  "China",
  "Macao",
  "Hong Kong",
  "Chile",
  "Chad",
  "Central African Rep.",
  "Cabo Verde",
  "Canada",
  "Cameroon",
  "Cambodia",
  "Myanmar",
  "Burundi",
  "Burkina Faso",
  "Bulgaria",
  "Brunei",
  "Brazil",
  "Botswana",
  "Bosnia and Herz.",
  "Bolivia",
  "Bhutan",
  "Benin",
  "Belize",
  "Belgium",
  "Belarus",
  "Barbados",
  "Bangladesh",
  "Bahrain",
  "Bahamas",
  "Azerbaijan",
  "Austria",
  "Australia",
  "Indian Ocean Ter.",
  "Heard I. and McDonald Is.",
  "Norfolk Island",
  "Ashmore and Cartier Is.",
  "Armenia",
  "Argentina",
  "Antigua and Barb.",
  "Angola",
  "Andorra",
  "Algeria",
  "Albania",
  "Afghanistan",
  "Siachen Glacier",
  "Antarctica",
  "Sint Maarten"
]

export const countriesJSONEsp = [
  "Zimbabue",
  "Zambia",
  "Yemen",
  "Vietnam",
  "Venezuela",
  "Vaticano",
  "Vanuatu",
  "Uzbekistán",
  "Uruguay",
  "Micronesia",
  "Marshall Is.",
  "N. Mariana Is.",
  "Islas Vírgenes de los Estados Unidos",
  "Guam",
  "Samoa Americana",
  "Puerto Rico",
  "Estados Unidos de América",
  "S. Geo. Y las Is.",
  "Hno. Océano Índico Ter.",
  "Santa Elena",
  "Islas Pitcairn",
  "Anguila",
  "Islas Malvinas",
  "Islas Caimán",
  "Islas Bermudas",
  "Islas Vírgenes Británicas",
  "Islas Turcas y Caicos",
  "Montserrat",
  "Jersey",
  "Guernsey",
  "Isla de Man",
  "Reino Unido",
  "Emiratos Árabes Unidos",
  "Ucrania",
  "Uganda",
  "Turkmenistán",
  "Turquía",
  "Túnez",
  "Trinidad y Tobago",
  "Tonga",
  "Togo",
  "Timor-Leste",
  "Tailandia",
  "Tanzania",
  "Tayikistán",
  "Taiwán",
  "Siria",
  "Suiza",
  "Suecia",
  "eSwatini",
  "Surinam",
  "Sudán",
  "Sudán del sur",
  "Sri Lanka",
  "España",
  "Corea del Sur",
  "Corea del Norte",
  "Sudáfrica",
  "Somalia",
  "Somalilandia",
  "Islas Salomón",
  "Eslovaquia",
  "Eslovenia",
  "Singapur",
  "Sierra Leona",
  "Seychelles",
  "Serbia",
  "Senegal",
  "Arabia Saudita",
  "Santo Tomé y Príncipe",
  "San Marino",
  "Samoa",
  "St. Vin. Y Gren.",
  "Santa Lucía",
  "Saint Kitts y Nevis",
  "Ruanda",
  "Rusia",
  "Rumania",
  "Katar",
  "Portugal",
  "Polonia",
  "Filipinas",
  "Perú",
  "Paraguay",
  "Papúa Nueva Guinea",
  "Panamá",
  "Palau",
  "Pakistán",
  "Omán",
  "Noruega",
  "Corea del Norte",
  "Nigeria",
  "Níger",
  "Nicaragua",
  "Nueva Zelanda",
  "Niue",
  "Islas Cook",
  "Países Bajos",
  "Aruba",
  "Curazao",
  "Nepal",
  "Nauru",
  "Namibia",
  "Mozambique",
  "Marruecos",
  "W. Sahara",
  "Montenegro",
  "Mongolia",
  "Moldavia",
  "Mónaco",
  "México",
  "Mauricio",
  "Mauritania",
  "Malta",
  "Malí",
  "Maldivas",
  "Malasia",
  "Malawi",
  "Madagascar",
  "Macedonia",
  "Luxemburgo",
  "Lituania",
  "Liechtenstein",
  "Libia",
  "Liberia",
  "Lesoto",
  "Líbano",
  "Letonia",
  "Laos",
  "Kirguistán",
  "Kuwait",
  "Kosovo",
  "Kiribati",
  "Kenia",
  "Kazajstán",
  "Jordán",
  "Japón",
  "Jamaica",
  "Italia",
  "Israel",
  "Palestina",
  "Irlanda",
  "Irak",
  "Irán",
  "Indonesia",
  "India",
  "Islandia",
  "Hungría",
  "Honduras",
  "Haití",
  "Guayana",
  "Guinea-Bissau",
  "Guinea",
  "Guatemala",
  "Granada",
  "Grecia",
  "Ghana",
  "Alemania",
  "Georgia",
  "Gambia",
  "Gabón",
  "Francia",
  "San Pedro y Miquelón",
  "Islas Wallis y Futuna",
  "St-Martin",
  "St-Barthélemy",
  "P. Polinesia",
  "Nueva Caledonia",
  "P. S. Antarctic Lands",
  "Åland",
  "Finlandia",
  "Fiji",
  "Etiopía",
  "Estonia",
  "Eritrea",
  "Eq. Guinea",
  "El Salvador",
  "Egipto",
  "Ecuador",
  "Rep. Dominicana",
  "Dominica",
  "Djibouti",
  "Groenlandia",
  "Islas Feroe",
  "Dinamarca",
  "República Checa",
  "N. Chipre",
  "Chipre",
  "Cuba",
  "Croacia",
  "Costa de Marfil",
  "Costa Rica",
  "República Democrática del Congo",
  "Congo",
  "Comoras",
  "Colombia",
  "China",
  "Macao",
  "Hong Kong",
  "Chile",
  "Chad",
  "Rep. Centroafricana",
  "Cabo Verde",
  "Canadá",
  "Camerún",
  "Camboya",
  "Myanmar",
  "Burundi",
  "Burkina Faso",
  "Bulgaria",
  "Brunei",
  "Brasil",
  "Botswana",
  "Bosnia y Herz.",
  "Bolivia",
  "Bután",
  "Benin",
  "Belice",
  "Bélgica",
  "Bielorrusia",
  "Barbados",
  "Bangladesh",
  "Bahréin",
  "Bahamas",
  "Azerbaiyán",
  "Austria",
  "Australia",
  "Océano Índico Ter.",
  "Islas Heard y Mcdonald",
  "Isla Norfolk",
  "Ashmore y Cartier Is.",
  "Armenia",
  "Argentina",
  "Antigua y Barb.",
  "Angola",
  "Andorra",
  "Argelia",
  "Albania",
  "Afganistán",
  "Glaciar Siachen",
  "Antártida",
  "Sint Maarten"
]

export const countriesDataEng = [
  "Argentina",
  "Bahamas",
  "Barbados",
  "Belize",
  "Bolivia",
  "Brazil",
  "Chile",
  "Colombia",
  "Costa Rica",
  "Cuba",
  "Dominican Rep.",
  "Ecuador",
  "El Salvador",
  "Guatemala",
  "Guyana",
  "Haiti",
  "Honduras",
  "Jamaica",
  "Mexico",
  "Nicaragua",
  "Panama",
  "Paraguay",
  "Peru",
  "St. Kitts and Nevis",
  "St. Lucia",
  "St. Vin. and Gren.",
  "Suriname",
  "Trinidad and Tobago",
  "Uzbekistan",
  "Uruguay",
  "Venezuela",
  "Albania",
  "Austria",
  "Belgium",
  "Belarus",
  "Bulgaria",
  "Croatia",
  "Cyprus",
  "Czechia",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hungary",
  "Iceland",
  "Ireland",
  "Italy",
  "Latvia",
  "Lithuania",
  "Malta",
  "Moldova",
  "Montenegro",
  "Netherlands",
  "Norway",
  "Poland",
  "Portugal",
  "Macedonia",
  "Romania",
  "Russia",
  "Slovakia",
  "Slovenia",
  "Spain",
  "Sweden",
  "Switzerland",
  "Ukraine",
  "United Kingdom",
  "Serbia",
  "Algeria",
  "Angola",
  "Benin",
  "Botswana",
  "Burkina Faso",
  "Burundi",
  "Cameroon",
  "Central African Rep.",
  "Chad",
  "Congo",
  "Dem. Rep. Congo",
  "Côte d'Ivoire",
  "Egypt",
  "Eq. Guinea",
  "Eritrea",
  "Ethiopia",
  "Gabon",
  "Gambia",
  "Ghana",
  "Guinea",
  "Guinea-Bissau",
  "Kenya",
  "Lesotho",
  "Liberia",
  "Libya",
  "Madagascar",
  "Malawi",
  "Mali",
  "Mauritania",
  "Mauritius",
  "Morocco",
  "Mozambique",
  "Namibia",
  "Niger",
  "Nigeria",
  "Rwanda",
  "São Tomé and Principe",
  "Senegal",
  "Seychelles",
  "Sierra Leone",
  "South Africa",
  "S. Sudan",
  "Sudan",
  "Swaziland",
  "Tanzania",
  "Togo",
  "Tunisia",
  "Uganda",
  "Zambia",
  "Zimbabwe",
  "Afghanistan",
  "Armenia",
  "Azerbaijan",
  "Bahrain",
  "Bangladesh",
  "Brunei",
  "Cambodia",
  "China",
  "Hong Kong",
  "Georgia",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Israel",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "South Korea",
  "North Korea",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Lebanon",
  "Malaysia",
  "Mongolia",
  "Myanmar",
  "Nepal",
  "Oman",
  "Pakistan",
  "Philippines",
  "Qatar",
  "Saudi Arabia",
  "Singapore",
  "Sri Lanka",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Thailand",
  "Turkey",
  "United Arab Emirates",
  "Uzbekistan",
  "Vietnam",
  "Yemen",
  "Australia",
  "New Zealand",
  "Canada",
  "United States of America",
  "Latin America",
  "Eastern Europe",
  "Sub Saharan Africa",
  "North Africa",
  "Middle East",
  "East Asia",
  "South Asia",
  "West Offshoots",
  "Western Europe",
  "World",
  "OECD",
  "The Rest"
]

export const countriesDataEsp = [
  "Argentina",
  "Bahamas",
  "Barbados",
  "Belice",
  "Bolivia",
  "Brasil",
  "Chile",
  "Colombia",
  "Costa Rica",
  "Cuba",
  "Rep.Dominicana",
  "Ecuador",
  "El Salvador",
  "Guatemala",
  "Guayana",
  "Haití",
  "Honduras",
  "Jamaica",
  "México",
  "Nicaragua",
  "Panamá",
  "Paraguay",
  "Perú",
  "Saint Kitts y Nevis",
  "Santa Lucía",
  "St. Vin. y Gren.",
  "Surinam",
  "Trinidad y Tobago",
  "Uzbekistán",
  "Uruguay",
  "Venezuela",
  "Albania",
  "Austria",
  "Bélgica",
  "Bielorrusia",
  "Bulgaria",
  "Croacia",
  "Chipre",
  "República Checa",
  "Dinamarca",
  "Estonia",
  "Finlandia",
  "Francia",
  "Alemania",
  "Grecia",
  "Hungría",
  "Islandia",
  "Irlanda",
  "Italia",
  "Letonia",
  "Lituania",
  "Malta",
  "Moldavia",
  "Montenegro",
  "Países Bajos",
  "Noruega",
  "Polonia",
  "Portugal",
  "Macedonia",
  "Rumania",
  "Rusia",
  "Eslovaquia",
  "Eslovenia",
  "España",
  "Suecia",
  "Suiza",
  "Ucrania",
  "Reino Unido",
  "Serbia",
  "Argelia",
  "Angola",
  "Benin",
  "Botswana",
  "Burkina Faso",
  "Burundi",
  "Camerún",
  "Rep. Centroafricana",
  "Chad",
  "Congo",
  "República Democrática del Congo",
  "Costa de Marfil",
  "Egipto",
  "Eq. Guinea",
  "Eritrea",
  "Etiopía",
  "Gabón",
  "Gambia",
  "Ghana",
  "Guinea",
  "Guinea-Bissau",
  "Kenia",
  "Lesoto",
  "Liberia",
  "Libia",
  "Madagascar",
  "Malawi",
  "Malí",
  "Mauritania",
  "Mauricio",
  "Marruecos",
  "Mozambique",
  "Namibia",
  "Níger",
  "Nigeria",
  "Ruanda",
  "Santo Tomé y Príncipe",
  "Senegal",
  "Seychelles",
  "Sierra Leona",
  "Sudáfrica",
  "Sudán",
  "Sudán del sur",
  "Swazilandia",
  "Tanzania",
  "Togo",
  "Túnez",
  "Uganda",
  "Zambia",
  "Zimbabue",
  "Afganistán",
  "Armenia",
  "Azerbaiyán",
  "Bahréin",
  "Bangladesh",
  "Brunei",
  "Camboya",
  "China",
  "Hong Kong",
  "Georgia",
  "India",
  "Indonesia",
  "Irán",
  "Irak",
  "Israel",
  "Japón",
  "Jordán",
  "Kazajstán",
  "Corea del Sur",
  "Corea del Norte",
  "Kuwait",
  "Kirguistán",
  "Laos",
  "Líbano",
  "Malasia",
  "Mongolia",
  "Myanmar",
  "Nepal",
  "Omán",
  "Pakistán",
  "Filipinas",
  "Katar",
  "Arabia Saudita",
  "Singapur",
  "Sri Lanka",
  "Siria",
  "Taiwán",
  "Tayikistán",
  "Tailandia",
  "Turquía",
  "Emiratos Árabes Unidos",
  "Uzbekistan",
  "Vietnam",
  "Yemen",
  "Australia",
  "Nueva Zelanda",
  "Canadá",
  "Estados Unidos de América",
  "América Latina",
  "Europa del Este",
  "Africa Sub-sahariana",
  "África del Norte",
  "Oriente Medio",
  "este de Asia",
  "Asia del Sur",
  "West Offshoots",
  "Europa Oriental",
  "Mundo",
  "OCDE",
  "El resto"
]
